/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'notifications': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 19.5',
    data: '<path pid="0" d="M8 19.5a1.752 1.752 0 0 0 .4-.04 2.029 2.029 0 0 0 1.44-1.18 2.008 2.008 0 0 0 .15-.78h-4a2.015 2.015 0 0 0 2.01 2zm6-11c0-3.07-1.64-5.64-4.5-6.32V1.5A1.5 1.5 0 0 0 8 0a1.5 1.5 0 0 0-1.5 1.5v.68C3.63 2.86 2 5.42 2 8.5v5l-2 2v1h16v-1l-2-2v-5z" fill-rule="evenodd"/>'
  }
})
